import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {App} from './app/app';
import '@tailwindplus/elements';
import * as Sentry from '@sentry/angular';
import {environment} from './environments/environment';
import {registerLocaleData} from '@angular/common';
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeNl);

if (environment.currentEnvironment === "production") {
  Sentry.init({
    dsn: "https://b294ea984ead95c8e619de22d3fcb602@o4509751290560512.ingest.de.sentry.io/4510232477565008",
    sendDefaultPii: true,
    enableLogs: true,
    environment: environment.currentEnvironment
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
